var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_2006)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_113_2006)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_113_2006)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_113_2006)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19603 20.8223L11.939 12.0953L3.19603 3.35228C2.98103 3.69928 2.83203 4.26228 2.83203 5.07428V19.1003C2.83203 19.9113 2.98103 20.4743 3.19603 20.8223ZM15.63 15.7873L12.766 12.9073L4.25603 21.4343H4.33903C5.06703 21.4343 5.69603 21.1693 6.70603 20.6233L15.63 15.7873ZM16.704 8.96528L13.591 12.0953L16.704 15.2083L18.592 14.1813C19.287 13.8013 20.347 13.1053 20.347 12.0953C20.347 11.0683 19.287 10.3723 18.592 9.99128L16.704 8.96528ZM4.25603 2.73828L12.766 11.2663L15.631 8.38628L6.70603 3.55028C5.69603 3.00328 5.06703 2.73828 4.33903 2.73828H4.25603Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_2006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_113_2006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_113_2006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_113_2006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreIcon);
export default __webpack_public_path__ + "static/media/playstore-icon.87328941450eaefeef30cf6a92db0711.svg";
export { ForwardRef as ReactComponent };